import { createContext } from 'react';
import { defaultState } from '.';

export const BasketContext = createContext(defaultState);
